export const DOCUMENTS_LIST = {
  DOCUMENTS_LIST: 'DOCUMENTS_LIST',
  SINGLE_DOCUMENT: 'SINGLE_DOCUMENT',
  DOWNLOAD: 'DOWNLOAD',
  HISTORY: 'HISTORY',
  COUNT: 'COUNT',
  DOCUMENT_TYPES: 'DOCUMENT_TYPES',
  AVAILABLE_TEMPLATES_CREATOR: 'AVAILABLE_TEMPLATES_CREATOR',
};
